import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../App.css';

import video1 from '../images/khram1.mp4';
import video2 from '../images/khram2.mp4';
import video3 from '../images/khram3.mp4';
import video4 from '../images/khram4.mp4';
import video5 from '../images/khram5.mp4';
import video6 from '../images/khram6.mp4';

const reports = [
  { id: 1, title: 'Этап строительства 1', video: video1 },
  { id: 2, title: 'Этап строительства 2', video: video2 },
  { id: 3, title: 'Этап строительства 3', video: video3 },
  { id: 4, title: 'Этап строительства 4', video: video4 },
  { id: 5, title: 'Этап строительства 5', video: video5 },
  { id: 6, title: 'Этап строительства 6', video: video6 }
];

function Build() {
  return (
    <main className="page-main">
      <Container className="inner-page pb-5">
        <section className="section-block">
          <div className="section-heading">
            <h2>Отчёты о строительстве нового храма</h2>
            <p>Видеоматериалы размещены прямо на сайте, без API и внешнего бэкенда.</p>
          </div>

          <Row className="g-4 mt-1">
            {reports.map((report) => (
              <Col key={report.id} xs={12} sm={6} lg={4}>
                <Card className="surface-card building-card h-100">
                  <video className="building-video" controls preload="none">
                    <source src={report.video} type="video/mp4" />
                  </video>
                  <Card.Body>
                    <Card.Text>{report.title}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </section>
      </Container>
    </main>
  );
}

export default Build;
